import { useLingui } from '@lingui/react';
import { AspectRatio, Card, Grid, Group, Image, Stack } from '@mantine/core';
import { CardTitle } from '../Shares/CardTitle';
import { games } from '../Shares/games';
export const SearchTopGames: React.FC = () => {
  const {
    i18n
  } = useLingui();
  const tops = games.find(item => item.id === 'tops');
  return <Card bg="var(--navbar-bg-color)" radius={5} mb="md">
      <Stack>
        <Group>
          <CardTitle firstText={i18n._('Top-Rated')} secondText={i18n._('Games')} isFirstGradient colorFrom="#FF5E9F" colorTo="#FF2E82" iconUrl="/assets/title-icons/2.png" mt={6} />
        </Group>

        <Grid>
          {tops?.items.map(item => <Grid.Col key={item.id} span={{
          base: 4,
          sm: 2.4,
          md: 1.714
        }}>
              <AspectRatio ratio={122 / 130}>
                <Image src={item.imgCard} alt={`game-${item.id}`} />
              </AspectRatio>
            </Grid.Col>)}
        </Grid>
      </Stack>
    </Card>;
};